import React from "react";
import { useRecordContext } from "react-admin";
import { useTravelerNames } from "components/Leaves/utils/useTravelerNames";

const TravelersField = () => {
  const record = useRecordContext();
  const names = useTravelerNames(record?.travelers);

  return <span>{names.filter(Boolean).join(", ")}</span>;
};

export default TravelersField;
